// ©2024 Austin App House. All rights reserved.
import React, { useState } from 'react';
import ContractorRating from '../../ContractorRating';
import ContractorCertificatesChecks from '../../ContractorCertificatesChecks';
import ContractorPreferedGroupsChecks from '../../PreferedGroupsCheck';
import AllRequestedWorkView from './AllRequestedWorkView';
import workOrderStatusControl from '../../../../utils/workOrderStatusControl';
import { localCurrencySettings } from '../../../../utils/constans';

const ApplicantCard = ({
    contractorInfo,
    setCurrentApplicants,
    toggleModal,
    currentWorkOrder,
    assignContractor,
    userType,
}) => {
    const [isShowAllWork, setIsShowAllWork] = useState(false);
    const [selectedApplies, setSelectedApplies] = useState([
        contractorInfo.work_order_id,
    ]);

    const contractor = contractorInfo.contractor_details || {};
    const workOrderControl = currentWorkOrder?.status
        ? workOrderStatusControl(currentWorkOrder.status)
        : {};

    const handleToggleAll = () => {
        if (isShowAllWork) {
            setSelectedApplies([contractorInfo.work_order_id]);
        }
        setIsShowAllWork(!isShowAllWork);
    };

    return (
        <>
            <div className="card_item">
                <div className="card_body" style={{ display: 'flex', alignItems: 'center' }}>

                    {/* Аватар */}
                    <div className="img_card">
                        <img
                            src={contractor.image || 'https://www.w3schools.com/css/img_avatar.png'}
                            alt="Avatar"
                            width="78"
                            height="78"
                        />

                        {contractor.groups?.length ? (
                            <div className="small_img">
                                <ContractorPreferedGroupsChecks />
                                {/* <span>Preferred groups</span> */}
                            </div>
                        ) : null}
                    </div>

                    {/* Основная инфо */}
                    <div className="card_main">
                        <div
                            className="card_title"
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                                toggleModal(true, 'contractorDetailsModal', true, {
                                    contractorId: contractor.userId,
                                })
                            }
                        >
                            {contractor.name} - {contractor.unique_id}
                        </div>

                        <div className="card_address">{contractor.address}</div>
                        <div className="card_address">
                            {(contractor.city?.label ? contractor.city.label + ', ' : '') +
                                (contractor.state?.label ? contractor.state.label + ', ' : '') +
                                (contractor.zipcode || '')}
                        </div>

                        <div className="card_contacts">
                            <div><a href={`tel:${contractor.phone}`}>{contractor.phone}</a></div>
                            <div><a href={`mailto:${contractor.email}`}>{contractor.email}</a></div>
                        </div>

                        <div className="card_address">
                            <span>
                                Base Pay:{' '}
                                {(+contractorInfo.bidAmountBase).toLocaleString('en-US', localCurrencySettings)}
                            </span>
                        </div>
                        <div className="card_address">
                            <span>
                                Variable Pay:{' '}
                                {(+contractorInfo.bidAmountVariable || 0).toLocaleString(
                                    'en-US',
                                    localCurrencySettings
                                )}
                            </span>
                        </div>

                        <div className="card_address">
                            Start Date: {new Date(contractorInfo.startDate).toLocaleDateString('en-US')}
                        </div>
                        <div className="card_address">
                            Start Time: {contractorInfo.startTime}
                        </div>
                        <br />
                        {/*<ul className="info_list">*/}
                        {contractorInfo.amountExpense || contractorInfo.descriptionExpense || contractorInfo.comment ? (
                            <div className="card_address"
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '6px',
                                    marginBottom: '12px',
                                }}
                            >
                                <span style={{ fontWeight: '700', fontSize: '15px' }}>Travel Expenses:</span>

                                {contractorInfo.amountExpense && (
                                    <span style={{ color: '#0484bb', fontWeight: '600' }}>
                                        <strong>Amount:</strong>{' '}
                                        {(+contractorInfo.amountExpense).toLocaleString('en-US', localCurrencySettings)}
                                    </span>
                                )}

                                {contractorInfo.descriptionExpense && (
                                    <>
                                        <span style={{ fontWeight: '600' }}>Travel Expense Description:</span>
                                        <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                            {contractorInfo.descriptionExpense}
                                        </span>
                                    </>
                                )}
                            </div>
                        ) : null}

                        {contractorInfo.comment && (
                            <div className="card_address"
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '4px',
                                    marginBottom: '8px',
                                }}
                            >
                                <span style={{ fontWeight: '600' }}>Comment</span>
                                <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                    {contractorInfo.comment}
                                </span>
                            </div>
                        )}
                        {/*</ul>*/}

                        <div style={{ cursor: 'pointer' }} onClick={handleToggleAll}>
                            <span style={{ textDecoration: 'underline' }}>
                                {isShowAllWork ? 'Hide requested work' : 'Show requested work'}
                            </span>
                        </div>
                    </div>

                    {/* Сертификаты */}
                    <div className="check_info">
                        <ContractorCertificatesChecks certificates={contractor.certificates} />
                    </div>

                    {/* Рейтинги */}
                    <div className="card_statuses">
                        <ContractorRating contractor={contractor} />
                    </div>

                    {/* Действия */}
                    <div className="card_actions">
                        {userType === 'client' && workOrderControl.beforeAssigned && !workOrderControl.canceled && (
                            <>
                                {Object.values(contractorInfo.block).some((v) => v) ? (
                                    <button
                                        type="button"
                                        className="standard_btn danger_btn"
                                        onClick={() =>
                                            toggleModal(true, 'blockModal', false, {
                                                contractorId: contractorInfo.contractor_id,
                                            })
                                        }
                                    >
                                        Blocked
                                    </button>
                                ) : (
                                    <button
                                        type="button"
                                        className="standard_btn dark_btn"
                                        disabled={contractorInfo.status === 'withdrawn'}
                                        onClick={() =>
                                            assignContractor(
                                                { workOrdersId: selectedApplies },
                                                contractorInfo.contractor_id
                                            )
                                        }
                                    >
                                        {contractorInfo.status === 'withdrawn' ? 'Withdrawn' : 'Assign'}
                                    </button>
                                )}
                            </>
                        )}

                        {userType === 'client' &&
                            !['apply', 'archived'].includes(contractorInfo.status) && (
                                <>
                                    <button className="standard_btn light_btn">Assigned</button>

                                    {!currentWorkOrder?.checkInOutDetails?.length && (
                                        <button
                                            className="standard_btn dark_btn"
                                            onClick={() => {
                                                toggleModal(true, 'unAssignModal', false, {
                                                    workOrdersId: [currentWorkOrder._id],
                                                });
                                                setCurrentApplicants(contractorInfo);
                                            }}
                                        >
                                            Un-assign
                                        </button>
                                    )}
                                </>
                            )}
                    </div>
                </div>
            </div>

            <AllRequestedWorkView
                isShowAllWork={isShowAllWork}
                contractor={contractorInfo}
                selectedApplies={selectedApplies}
                selectApplies={setSelectedApplies}
            />
        </>
    );
};

export default ApplicantCard;